<template>
    <div v-click-outside="hide" :class="['item', 'px-lg', { 'bg-neutral-dark': dark }]">
        <button class="text-white" @click="expanded = !expanded">
            <font-awesome-icon
                v-if="icon"
                :icon="icon"
                class="mr-xs"
            />
            {{ name }}
        </button>

        <div v-if="expanded" class="submenu">
            <slot />
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';

    export default {

        directives: {
            ClickOutside,
        },
        props: {
            name: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                default: null,
            },
            dark: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data() {
            return {
                expanded: false,
            };
        },

        methods: {
            hide() {
                this.expanded = false;
            },
        },
    };
</script>